export default {
  title: 'Playground',

  navigation: {
    squircle: 'Squircle',
    sticker: 'Sticker',
    button: 'Button',
    tag: 'Tag',
    gSelect: 'GSelect',
    gTextField: 'GTextField',
    gTextarea: 'GTextarea',
    gSnackbar: 'GSnackbar',
    contactLists: 'ContactLists'
  },

  squircle: {
    title: 'Squircle'
  },

  sticker: {
    title: 'Sticker',

    statuses: {
      active: 'Active'
    }
  },

  button: {
    title: 'Button'
  },

  tag: {
    title: 'Tag'
  },

  g: {
    select: {
      title: 'GSelect'
    },

    'text-field': {
      title: 'GTextField'
    },

    textarea: {
      title: 'GTextarea'
    },

    snackbar: {
      title: 'GSnackbar'
    }
  },

  contactLists: {
    title: 'ContactLists',

    groups: {
      controls: 'Controls',
      transport: 'Transport and routing',
      create: 'Create',
      get: 'Get',
      find: 'Find',
      update: 'Update',
      remove: 'Remove'
    },

    labels: {
      controls: 'Case run',
      fixture: 'Fixture',
      expected: 'Expected',
      actual: 'Response',
      cleanupError: 'The created record was not removed',
      log: 'Request log',
      logEmpty: 'No requests yet'
    },

    actions: {
      run: 'Run',
      runAll: 'Run all',
      createFixture: 'Create fixture',
      removeFixture: 'Remove fixture',
      reset: 'Reset',
      clearLog: 'Clear log'
    },

    cases: {
      transport: {
        invalidToken: 'The token in the Authorization header does not pass validation',
        unknownPath: 'The path is not declared in the API routes',
        wrongMethod: 'The PATCH method is not declared for the resource',
        malformedBody: 'The request body is not valid JSON'
      },

      create: {
        emptyBody: 'Create without required fields',
        emptyTitle: 'Empty title',
        htmlTitle: 'title contains only an HTML tag and is stripped by the sanitizer',
        longTitle: 'title is longer than 150 characters',
        forbiddenCharacterTitle: 'title contains a character outside the allowed set',
        numberTitle: 'title is sent as a number and is cast to a string',
        unknownType: 'An unknown type is replaced with regular',
        invalidOwnerId: 'An invalid OwnerId is dropped and replaced with the token owner'
      },

      get: {
        missing: 'Request for a list that does not exist',
        invalidId: 'The identifier cannot be cast to the uuid type',
        objectScope: 'The $scope parameter is sent as an object instead of a string or an array'
      },

      find: {
        limitNotNumber: 'The $limit parameter is not a number',
        limitNegative: 'The $limit parameter is less than zero',
        offsetNotNumber: 'The $offset parameter is not a number',
        objectOrder: 'The $order parameter is sent as an object instead of a string or an array',
        invalidIdFilter: 'The id filter with an invalid uuid is dropped and the whole selection is returned'
      },

      update: {
        missing: 'Update of a list that does not exist',
        invalidId: 'The identifier cannot be cast to the uuid type',
        emptyTitle: 'Empty title on an existing list',
        longTitle: 'title is longer than 150 characters on an existing list',
        forbiddenCharacterTitle: 'title contains a character outside the allowed set on an existing list',
        idInBody: 'The id field in the request body is ignored'
      },

      remove: {
        missing: 'Removal of a list that does not exist',
        invalidId: 'The identifier cannot be cast to the uuid type'
      }
    }
  },

  groups: {
    sizes: 'Sizes',
    lineHeight: 'Line-height',
    modes: 'Modes',
    states: 'States',
    filledColors: 'Filled colors',
    outlineColors: 'Outline colors',
    iconContent: 'Content with icon',
    iconSizes: 'Icon and label: sizes',
    iconOnlySizes: 'Icon only: sizes',
    iconModes: 'Icon and label: modes',
    iconSamples: 'Different icons',
    iconStates: 'States with icon',
    content: 'Content',
    colors: 'Colors',
    links: 'Links and click',
    actions: 'Actions',
    borders: 'Borders',
    progress: 'Progress',
    messages: 'Hints and validation',
    multiple: 'Multiple selection',
    selection: 'Selected item',
    dropdown: 'Dropdown',
    rows: 'Height and width',
    types: 'Types',
    interactive: 'Interactive examples',
    iconSVG: 'iconSVG',
    icons: 'Icons',
    affixes: 'Prefixes and suffixes',
    tooltip: 'Tooltip',
    fullWidth: 'Full width',
    slot: 'Slot',
    features: 'Features',
    as: 'As',
    styles: 'Styles',
    limits: 'Limits',
    resize: 'Resize',
    itemConfig: 'Item config',
    freeInput: 'Free input',
    service: 'Loading from service',
    button: 'Button',
    badges: 'Badges',
    width: 'Width',
    target: 'Target',
    allIcons: 'All icons',
    allColors: 'All colors',
    duration: 'Duration'
  },

  empty: {
    icons: 'Nothing found'
  },

  labels: {
    button: 'Button',
    copyIcon: 'Click to copy icon',
    copyColor: 'Click to copy color',
    defaultSlot: 'Default slot',
    detailsAndCount: 'Hint and count',
    detailsFalse: 'Without details block',
    dropdownSlots: 'menuProps, icons and slots',
    growFalse: 'grow disabled with multiline value',
    growInput: 'Height growth on input',
    growLongValue: 'grow with multiline value',
    growShortValue: 'grow with short value',
    iconColorAndSize: 'iconColor and iconSize',
    inputError: 'Error text',
    inputHint: 'Hint text',
    inputLabel: 'Label',
    inputPlaceholder: 'Placeholder text',
    inputValue: 'Field value',
    interactiveTag: 'Removable tag',
    itemConfig: 'itemsPrepend, itemsDisabled, itemTitle, itemValue, itemDisabled and picks',
    longLabel: 'A very long label that does not fit into a single line',
    maskCard: 'Card mask',
    maskPhone: 'Phone mask',
    multipleHideSelections: 'multiple and hideSelections',
    restoreTag: 'Restore tag',
    runAllCases: 'Run all cases',
    servicePaths: 'service, pathToId, pathToTitle and translatePath',
    singleClearable: 'single and clearable',
    snackbarActionResult: 'Snackbar action is done',
    snackbarDurationText: 'Snackbar with duration in seconds:',
    snackbarQueueText: 'Queue snackbar',
    snackbarText: 'Short snackbar text',
    stickerLabel: 'Sticker description',
    stickerValue: 'Sticker title',
    tag: 'Tag',
    tooltip: 'Tooltip text'
  }
}
